<div class="bill-generation-container">
  <!-- Page Header with Back Navigation -->
  <div class="page-header-section">
    <div class="back-navigation">
      <button mat-button (click)="onBack()" class="back-btn">
        <mat-icon>arrow_back</mat-icon>
        Back to Trip Summary
      </button>
    </div>

    <app-page-header
      [title]="'Bill Generation'"
      [subtitle]="'Add extras and generate final bill'"
      [showDate]="false"
    ></app-page-header>
  </div>

  <div class="bill-generation-content">
    <div class="bill-generation-grid">
      <!-- Left Column - Add-ons and Discounts -->
      <div class="input-sections">
        <!-- Add-ons Section -->
        <div class="section-card">
          <div class="section-header">
            <h3>
              <mat-icon>add_circle</mat-icon>
              Add-ons
            </h3>
          </div>

          <form [formGroup]="addonForm" class="addon-form">
            <div class="form-row">
              <div class="form-field">
                <app-mat-input
                  [control]="addonForm.get('name')"
                  label="Add-on Name"
                  placeholder="e.g., Fuel surcharge"
                  [required]="true"
                ></app-mat-input>
              </div>

              <div class="form-field">
                <app-mat-input
                  [control]="addonForm.get('amount')"
                  label="Amount"
                  type="number"
                  placeholder="0"
                  [required]="true"
                  [min]="0"
                ></app-mat-input>
              </div>
            </div>

            <div class="form-actions">
              <button
                type="button"
                mat-raised-button
                color="primary"
                (click)="addAddon()"
                [disabled]="addonForm.invalid"
                class="add-btn"
              >
                <mat-icon>add</mat-icon>
                Add Item
              </button>
            </div>
          </form>

          <!-- Added Items List -->
          <div class="added-items" *ngIf="addons.length > 0">
            <h4>Added Items:</h4>
            <div class="item-list">
              <div class="item" *ngFor="let addon of addons">
                <div class="item-info">
                  <span class="item-name">{{ addon.name }}</span>
                  <span class="item-amount">{{
                    formatCurrency(addon.amount)
                  }}</span>
                </div>
                <button
                  mat-icon-button
                  color="warn"
                  (click)="removeAddon(addon.id)"
                  class="remove-btn"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Discount Section -->
        <div class="section-card">
          <div class="section-header">
            <h3>
              <mat-icon>remove_circle</mat-icon>
              Discount
            </h3>
          </div>

          <form [formGroup]="discountForm" class="discount-form">
            <div class="form-row">
              <div class="form-field">
                <app-mat-input
                  [control]="discountForm.get('name')"
                  label="Discount Name"
                  placeholder="e.g., Early payment discount"
                  [required]="true"
                ></app-mat-input>
              </div>

              <div class="form-field">
                <app-mat-input
                  [control]="discountForm.get('amount')"
                  label="Amount"
                  type="number"
                  placeholder="0"
                  [required]="true"
                  [min]="0"
                ></app-mat-input>
              </div>
            </div>

            <div class="form-actions">
              <button
                type="button"
                mat-raised-button
                color="accent"
                (click)="addDiscount()"
                [disabled]="discountForm.invalid"
                class="add-btn"
              >
                <mat-icon>add</mat-icon>
                Add Discount
              </button>
            </div>
          </form>

          <!-- Added Discounts List -->
          <div class="added-items" *ngIf="discounts.length > 0">
            <h4>Added Discounts:</h4>
            <div class="item-list">
              <div class="item" *ngFor="let discount of discounts">
                <div class="item-info">
                  <span class="item-name">{{ discount.name }}</span>
                  <span class="item-amount discount-amount"
                    >-{{ formatCurrency(discount.amount) }}</span
                  >
                </div>
                <button
                  mat-icon-button
                  color="warn"
                  (click)="removeDiscount(discount.id)"
                  class="remove-btn"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column - Bill Summary -->
      <div class="bill-summary-section">
        <div class="section-card">
          <div class="section-header">
            <h3>
              <mat-icon>receipt</mat-icon>
              Bill Summary
            </h3>
          </div>

          <div class="summary-details">
            <div class="summary-item">
              <span class="label">Subtotal ({{ totalTrips }} trips):</span>
              <span class="value">{{ formatCurrency(subtotal) }}</span>
            </div>

            <!-- Add-ons in Summary -->
            <div class="summary-item" *ngFor="let addon of addons">
              <span class="label">{{ addon.name }}:</span>
              <span class="value">{{ formatCurrency(addon.amount) }}</span>
            </div>

            <!-- Discounts in Summary -->
            <div
              class="summary-item discount-item"
              *ngFor="let discount of discounts"
            >
              <span class="label">{{ discount.name }}:</span>
              <span class="value discount-value"
                >-{{ formatCurrency(discount.amount) }}</span
              >
            </div>

            <div class="summary-item total-amount">
              <span class="label">Total Amount:</span>
              <span class="value">{{ formatCurrency(totalAmount) }}</span>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="action-buttons">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="generateBill()"
              [disabled]="isGenerating"
              class="generate-btn"
            >
              <mat-icon *ngIf="!isGenerating">receipt</mat-icon>
              <mat-spinner *ngIf="isGenerating" diameter="20"></mat-spinner>
              {{ isGenerating ? "Generating Bill..." : "Generate Bill" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
